<section class="content">
  <div class="content-block">
    <div class="row clearfix">
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h5 class="mb-0">Dossiers patients</h5>
          </div>

          <!-- Filtres -->
          <div class="card-body pb-2">
            <div class="filter-bar d-flex flex-wrap gap-2 align-items-end">
              <div>
                <label class="filter-label">Du</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="dateDebut">
              </div>
              <div>
                <label class="filter-label">Au</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFin">
              </div>
              <div style="min-width:200px">
                <label class="filter-label">Recherche</label>
                <input type="text" class="form-control form-control-sm" placeholder="Matricule, nom..."
                  [(ngModel)]="searchKey" (keyup.enter)="onSearch()">
              </div>
              <button class="btn btn-sm btn-primary" (click)="onSearch()">
                <i class="material-icons-outlined" style="font-size:15px;vertical-align:middle">search</i>
                Rechercher
              </button>
            </div>
          </div>

          <!-- Tableau -->
          <div class="card-body pt-1">
            <div class="table-scroll-wrapper">
              <table class="histo-table table table-sm table-hover mb-0">
                <thead class="custom-table-head">
                  <tr>
                    <th class="th-fixed sticky-col sticky-col-0">Date</th>
                    <th class="th-fixed sticky-col sticky-col-1">Patient</th>
                    <th class="th-fixed">Médecin</th>
                    <th class="th-actes">Actes prescrits</th>
                    <th class="th-fixed text-center">Consult. optique</th>
                    <th class="th-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Loading -->
                  <tr *ngIf="loadingList">
                    <td colspan="5" class="text-center py-4">
                      <span class="spinner-border spinner-border-sm mr-1"></span> Chargement...
                    </td>
                  </tr>
                  <!-- Vide -->
                  <tr *ngIf="!loadingList && items.length === 0">
                    <td colspan="5" class="empty-state">
                      Aucune consultation trouvée
                    </td>
                  </tr>
                  <!-- Lignes -->
                  <tr *ngFor="let item of items; let i = index"
                    [class.row-locked]="item.statut !== 'ATTENTE_PREVALIDATION_PRESTATAIRE'"
                    [class.row-alt]="i % 2 === 1">

                    <td class="date-cell sticky-col sticky-col-0">{{ item.created_at | date:'dd/MM/yyyy' }}</td>
                    <td class="sticky-col sticky-col-1">
                      <strong>{{ item.beneficiaire_nom }} {{ item.beneficiaire_prenom }}</strong>
                      <br>
                      <small>{{ item.matricule }}</small>
                      <br *ngIf="item.police_libelle">
                      <small class="text-muted" *ngIf="item.police_libelle">{{ item.police_libelle }}</small>
                    </td>
                    <td>
                      <strong>{{ ((item.praticien_nom || '') + ' ' + (item.praticien_prenom || '')).trim() || '—'
                        }}</strong>
                    </td>
                    <td class="actes-cell">
                      <div class="actes-badges">
                        <ng-container *ngFor="let col of GARANTIE_COLS">
                          <span *ngIf="(item[col.countKey] ?? 0) > 0"
                            class="acte-badge acte-badge-{{ col.codif.toLowerCase() }}"
                            [title]="col.label + ' — ' + (ordCounts[item.id + '_' + col.codif] ?? '…') + ' ord. / ' + item[col.countKey] + ' acte(s)'"
                            style="cursor:pointer" (click)="ouvrirListePrescrire(item, col); $event.stopPropagation()">
                            <span class="acte-count">{{ ordCounts[item.id + '_' + col.codif] ?? '…' }}</span>
                            &nbsp;{{ col.label }}&nbsp;
                            <span class="acte-count-sub">({{ item[col.countKey] }}&nbsp;{{ col.isOrdonnance ? 'méd.' :
                              'pres.' }})</span>
                          </span>
                        </ng-container>
                        <span *ngIf="!hasAnyActe(item)" class="empty-count">—</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span *ngIf="(item.count_cons_opt_non_hospit ?? 0) > 0"
                        class="badge bg-success" style="font-size:0.75rem;cursor:pointer"
                        (click)="ouvrirConsOptModal(item); $event.stopPropagation()">
                        <i class="material-icons-outlined" style="font-size:12px;vertical-align:middle">visibility</i>
                        {{ item.count_cons_opt_non_hospit }}
                      </span>
                      <span *ngIf="!(item.count_cons_opt_non_hospit ?? 0)" class="text-muted">—</span>
                    </td>
                    <td class="act-cell">
                      <ng-container *ngIf="item.statut === 'ATTENTE_PREVALIDATION_PRESTATAIRE'; else lockedTpl">
                        <button class="btn-prescrire" (click)="ouvrirHub(item)">
                          <i class="material-icons-outlined" style="font-size:13px;vertical-align:middle">edit_note</i>
                          Prescrire
                        </button>
                      </ng-container>
                      <ng-template #lockedTpl>
                        <span class="statut-pill" [title]="item.statut || ''">—</span>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginator -->
            <div class="paginator-wrap mt-2">
              <mat-paginator [length]="totalItems" [pageSize]="size" [pageIndex]="index"
                [pageSizeOptions]="[10, 25, 50]" (page)="onPageChange($event)" showFirstLastButtons>
              </mat-paginator>
            </div><!-- /paginator-wrap -->
          </div><!-- /card-body -->
        </div><!-- /card -->
      </div><!-- /col-12 -->
    </div><!-- /row -->
  </div><!-- /content-block -->
</section>

<!-- ══ Hub prescriptions ══════════════════════════════════════════════ -->
<div *ngIf="showHubModal" class="hub-overlay">
  <div class="hub-container" (click)="$event.stopPropagation()">
    <app-prescription-hub [consultation]="hubConsultation" [beneficiaire]="hubBeneficiaire" (onClose)="fermerHub()">
    </app-prescription-hub>
  </div>
</div>

<!-- ══ Modal consultations optiques ══════════════════════════════════ -->
<div *ngIf="showConsOptModal" class="hub-overlay">
  <div class="liste-modal" style="max-width:800px" (click)="$event.stopPropagation()">
    <div class="liste-modal-header">
      <span>{{ consOptModalTitle }}</span>
      <button class="close-btn" (click)="fermerConsOptModal()">×</button>
    </div>
    <div class="liste-modal-body">
      <div *ngIf="loadingConsOpt" class="text-center py-4">
        <span class="spinner-border spinner-border-sm"></span> Chargement...
      </div>
      <div *ngIf="!loadingConsOpt && !consOptItems.length" class="text-center py-4 text-muted">
        Aucune consultation optique trouvée
      </div>
      <ng-container *ngIf="!loadingConsOpt && consOptItems.length">
        <table class="liste-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Praticien</th>
              <th>Affection</th>
              <th>OD (SPH / CYL / AXE / ADD)</th>
              <th>OG (SPH / CYL / AXE / ADD)</th>
              <th>D.I.</th>
              <th>Options</th>
              <th>Observation</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let co of consOptItems; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="nowrap-cell">{{ co.created_at | date:'dd/MM/yyyy' }}</td>
              <td>{{ co.praticien_nom ? co.praticien_nom + ' ' + (co.praticien_prenom || '') : '—' }}</td>
              <td>{{ co.affection_libelle || '—' }}</td>
              <td class="nowrap-cell">
                {{ co.oeil_droit_sph || '—' }} /
                {{ co.oeil_droit_cyl || '—' }} /
                {{ co.oeil_droit_axe || '—' }} /
                {{ co.oeil_droit_add || '—' }}
              </td>
              <td class="nowrap-cell">
                {{ co.oeil_gauche_sph || '—' }} /
                {{ co.oeil_gauche_cyl || '—' }} /
                {{ co.oeil_gauche_axe || '—' }} /
                {{ co.oeil_gauche_add || '—' }}
              </td>
              <td>{{ co.distance_interpupillaire || '—' }}</td>
              <td style="font-size:0.72rem">
                <span *ngIf="co.filtre_anti_uv == '1' || co.filtre_anti_uv === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Anti-UV</span>
                <span *ngIf="co.filtre_photocromique == '1' || co.filtre_photocromique === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Photo</span>
                <span *ngIf="co.filtre_bleu == '1' || co.filtre_bleu === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Bleu</span>
                <span *ngIf="co.traitement_antireflet == '1' || co.traitement_antireflet === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Anti-reflet</span>
                <span *ngIf="co.traitement_teinte == '1' || co.traitement_teinte === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Teinte</span>
                <span *ngIf="co.type_progressif == '1' || co.type_progressif === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Progressif</span>
                <span *ngIf="co.type_double_foyer == '1' || co.type_double_foyer === true" class="acte-badge" style="background:#0665aa;color:#fff;border-radius:10px;padding:1px 6px">Double foyer</span>
                <span *ngIf="!co.filtre_anti_uv && !co.filtre_photocromique && !co.filtre_bleu && !co.traitement_antireflet && !co.traitement_teinte && !co.type_progressif && !co.type_double_foyer" class="text-muted">—</span>
              </td>
              <td>{{ co.observation || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
    <div class="liste-modal-footer">
      <button class="btn btn-sm btn-outline-secondary" (click)="fermerConsOptModal()">Fermer</button>
    </div>
  </div>
</div>

<!-- ══ Modal liste prescriptions ══════════════════════════════════════ -->
<div *ngIf="showListeModal" class="hub-overlay">
  <div class="liste-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="liste-modal-header">
      <span>{{ listeModalTitle }}</span>
      <button class="close-btn" (click)="fermerListeModal()">×</button>
    </div>
    <!-- Body -->
    <div class="liste-modal-body">
      <div *ngIf="loadingListe" class="text-center py-4">
        <span class="spinner-border spinner-border-sm"></span> Chargement...
      </div>
      <div *ngIf="!loadingListe && !listeModalItems.length" class="text-center py-4 text-muted">
        Aucune donnée trouvée
      </div>

      <!-- ── LISTE ORDONNANCES avec toggle détail (tous les cas) ── -->
      <ng-container *ngIf="!loadingListe && listeModalItems.length">
        <table class="liste-table">
          <thead>
            <tr>
              <th></th>
              <th>#</th>
              <th>Date</th>
              <th>Affection</th>
              <th>Praticien</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let ord of listeModalItems; let i = index">
              <!-- Ligne ordonnance parente -->
              <tr class="ord-row" (click)="toggleOrdonnanceDetail(ord)" style="cursor:pointer">
                <td class="toggle-cell">
                  <span class="toggle-icon">{{ expandedOrdonnanceIds.has(ord.id) ? '▼' : '▶' }}</span>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ ord.created_at | date:'dd/MM/yyyy' }}</td>
                <td>{{ ord.affection_libelle || '—' }}</td>
                <td>{{ ord.praticien_nom ? ord.praticien_nom + ' ' + (ord.praticien_prenom || '') : '—' }}</td>
                <td>
                  <span class="badge" [ngClass]="ord.is_factured ? 'bg-secondary' : 'bg-success'">
                    {{ ord.is_factured ? 'Facturé' : 'En attente' }}
                  </span>
                </td>
              </tr>
              <!-- Détail (toggle) -->
              <tr *ngIf="expandedOrdonnanceIds.has(ord.id)">
                <td colspan="6" class="detail-cell">
                  <div *ngIf="loadingDetailId === ord.id" class="text-center py-2">
                    <span class="spinner-border spinner-border-sm"></span>
                  </div>
                  <div *ngIf="loadingDetailId !== ord.id && ordonnanceDetails[ord.id]" class="detail-side-by-side">

                    <!-- Tableau PRESCRIPTION (gauche) -->
                    <div class="detail-half">
                      <div class="detail-half-title">Prescription</div>
                      <table class="detail-table">
                        <thead>
                          <tr *ngIf="listeModalCol?.isOrdonnance">
                            <th>#</th>
                            <th>Médicament</th>
                            <th>Posologie</th>
                            <th>Qté</th>
                            <th>Durée</th>
                            <th>Statut</th>
                          </tr>
                          <tr *ngIf="!listeModalCol?.isOrdonnance">
                            <th>#</th>
                            <th>Acte</th>
                            <th>Qté</th>
                            <th>Statut</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="!ordonnanceDetails[ord.id].prescriptions?.length">
                            <td colspan="6" class="text-center text-muted py-2" style="font-size:0.78rem">Aucune
                              prescription</td>
                          </tr>
                          <!-- PHARMA -->
                          <ng-container *ngIf="listeModalCol?.isOrdonnance">
                            <tr *ngFor="let med of ordonnanceDetails[ord.id].prescriptions; let j = index">
                              <td>{{ j + 1 }}</td>
                              <td class="med-name-cell">{{ med.medicament_libelle || med.libelle }}</td>
                              <td class="pos-detail-cell" [title]="med.posologie">
                                <span class="pos-detail-text">{{ med.posologie || '—' }}</span>
                              </td>
                              <td>{{ med.quantite }}</td>
                              <td class="nowrap-cell">{{ med.duree ? med.duree + 'j' : '—' }}</td>
                              <td>
                                <span class="statut-badge" [class.badge-danger]="med.is_exclu"
                                  [class.badge-warning]="!med.is_exclu && med.is_entente_prealable"
                                  [class.badge-success]="!med.is_exclu && !med.is_entente_prealable">
                                  {{ med.is_exclu ? 'Non garanti' : med.is_entente_prealable ? 'EP' : 'Garanti' }}
                                </span>
                              </td>
                            </tr>
                          </ng-container>
                          <!-- ACTES -->
                          <ng-container *ngIf="!listeModalCol?.isOrdonnance">
                            <tr *ngFor="let acte of ordonnanceDetails[ord.id].prescriptions; let j = index">
                              <td>{{ j + 1 }}</td>
                              <td>{{ acte.acte_libelle || acte.libelle }}</td>
                              <td>{{ acte.quantite }}</td>
                              <td>
                                <span class="badge"
                                  [ngClass]="acte.is_exclu ? 'bg-danger' : acte.is_entente_prealable ? 'bg-warning text-dark' : 'bg-success'">
                                  {{ acte.is_exclu ? 'Non garanti' : acte.is_entente_prealable ? 'Entente préalable' :
                                  'Garanti' }}
                                </span>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>

                    <!-- Tableau PRESTATION EXÉCUTÉE (droite) -->
                    <div class="detail-half">
                      <div class="detail-half-title exec-title">Exécutions</div>
                      <table class="detail-table">
                        <thead>
                          <tr *ngIf="listeModalCol?.isOrdonnance">
                            <th>#</th>
                            <th>Médicament</th>
                            <th>Qté accordée</th>
                            <th>Date</th>
                            <th>Statut</th>
                          </tr>
                          <tr *ngIf="!listeModalCol?.isOrdonnance">
                            <th>#</th>
                            <th>Acte</th>
                            <th>Qté accordée</th>
                            <th>Date</th>
                            <th>Statut</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="!ordonnanceDetails[ord.id].executions?.length">
                            <td colspan="5" class="text-center text-muted py-2" style="font-size:0.78rem">Aucune
                              exécution</td>
                          </tr>
                          <tr *ngFor="let ex of ordonnanceDetails[ord.id].executions; let k = index">
                            <td>{{ k + 1 }}</td>
                            <td class="med-name-cell">{{ ex.medicament_libelle || ex.acte_libelle || ex.libelle }}</td>
                            <td>{{ ex.quantite_accord ?? ex.quantite }}</td>
                            <td class="nowrap-cell">{{ ex.created_at | date:'dd/MM/yyyy' }}</td>
                            <td>
                              <span class="statut-badge" [class.badge-secondary]="ex.is_factured"
                                [class.badge-info]="!ex.is_factured">
                                {{ ex.is_factured ? 'Facturé' : 'Exécuté' }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
    </div>
    <!-- Footer -->
    <div class="liste-modal-footer">
      <button class="btn btn-sm btn-outline-secondary" (click)="fermerListeModal()">Fermer</button>
    </div>
  </div>
</div>